import * as CatCentersActions from '../adm-cat-centers.actions'
import { IDS } from '../../adm-categorisation-action-id.constants'
/**
 * AdmCatCenterModulesController.
 * @class
 * @memberOf Administration
 */
class AdmCatCenterModulesController {
    constructor($ngRedux, $state, $scope, Notifier, NavigationActions) {
        this.$ngRedux           = $ngRedux;
        this.$state             = $state;
        this.$scope             = $scope;
        this.Notifier           = Notifier;
        this.NavigationActions  = NavigationActions;
    }

    $onInit() {
        this.identifier = IDS.admCatCenterModules;
        this.unsubscribe = this.$ngRedux.connect(
            state => {
                const admCategorisation = state.administration.admCategorisation;
                return {
                    centerTypeName: admCategorisation.admCatCenterDetails.name,
                    centerTypeId:   admCategorisation.admCatCenterDetails.sty_id,
                    activeModules:  admCategorisation.admCatCenterModules.map(item => ({
                        id: item.id,
                        active: item.active,
                    })),
                }
            },
            CatCentersActions
        )(this);
    }

    onSubmit() {
        this.updateActiveModules(this.centerTypeId, this.activeModules);
    }

    $onDestroy() {
        this.unsubscribe();
    }
}

AdmCatCenterModulesController.$inject = ['$ngRedux', '$state', '$scope', 'Notifier', 'NavigationActions']

export const admCatCenterModules = {
    controller: AdmCatCenterModulesController,

    template: `
        <tabs-header title="{{$ctrl.centerTypeName}}"></tabs-header>
        
        <form id="modulesForm" name="$ctrl.modulesForm" style="margin-bottom: 15px;" novalidate>
            <div layout="column">
                <md-divider></md-divider>
                <md-content flex>
                    <section>
                        <input-checkbox-list
                                identifier="admCategorisation.admCatCenterModules"
                                property-name="active"
                                columns-count="3">
                        </input-checkbox-list>
                    </section>
                </md-content>
                <md-divider></md-divider>
            </div>
        </form>
        <tabs-navigation identifier="app.administration.categorisation.centers"
                         state="app.administration.categorisation.centers.modules"
                         on-exec="$ctrl.onSubmit()">
        </tabs-navigation>`
}
